/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sets: NonNullable<unknown>, reps: NonNullable<unknown> }} Plan_Dose_RepsInputs */

const en_us2_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const pt_br2_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const es_419_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const pt_pt2_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const fr_fr2_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const de_de2_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

const it_it2_plan_dose_reps = /** @type {(inputs: Plan_Dose_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sets} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{sets} × {reps}" |
*
* @param {Plan_Dose_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_dose_reps = /** @type {((inputs: Plan_Dose_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Dose_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_dose_reps(inputs)
	if (locale === "es-419") return es_419_plan_dose_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_dose_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_dose_reps(inputs)
	if (locale === "de-DE") return de_de2_plan_dose_reps(inputs)
	if (locale === "it-IT") return it_it2_plan_dose_reps(inputs)
	return en_us2_plan_dose_reps(inputs)
});
export { plan_dose_reps as "plan.dose_reps" }